// extracted by mini-css-extract-plugin
export default {"background":"wXXHX8","container":"UZJLP7","cards":"rULF5d","responsiveCards":"WkyYZe","padding":"qyvevE"};